<template>

    <v-list-item class="element">

        <transition name="modal">
            <v-modal-element-delete v-if="showModal === `element-delete-${el.id}`" :el="el" />
            <v-modal-element-edit v-if="showModal === `element-edit-${el.id}`" :el="el" />
        </transition>

        <div class="d-flex align-items-center">
            <v-handle class="mr-10" :size="24" />
            <v-icon class="mr-10" :type="el.type" />
            <div class="info">
                <span>{{ el.label || el.placeholder | truncate(50) }} <span class="text-danger">{{ el.required ? '*' : '' }}</span></span><br>
                <span class="small text-secondary">{{ el.type }}</span>
            </div>
        </div>
        <div>
            <v-button-toolbar class="float-right">
                <v-button size="sm" @click.native="editElement">Edit</v-button>
                <v-dropdown
                    type="secondary"
                    label="More"
                    :items="options"
                    :show-selected="false"
                    :menu-right="true"
                    @change="onOptionSelected">
                </v-dropdown>
            </v-button-toolbar>
        </div>

    </v-list-item>

</template>

<style scoped lang="scss">

    .list-item.element {
        grid-auto-columns: 1fr 200px;
        .info {
            text-overflow: ellipsis;
        }
    }

</style>

<script>

import ElementIcon from './ElementIcon';
import ModalFormElementDelete from '@modals/form/ModalFormElementDelete';
import ModalFormElementEdit from '@modals/form/ModalFormElementEdit';

export default {

    components: {
        'v-icon': ElementIcon,
        'v-modal-element-delete': ModalFormElementDelete,
        'v-modal-element-edit': ModalFormElementEdit,
    },

    props: {
        el: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            options: [
                { key: 'element-delete', value: 'Delete Element' }
            ],
        }
    },

    computed: {

        form() {
            return this.$store.getters['form/form'];
        },

    },

    methods: {

        onOptionSelected(item) {
            this.$store.commit('showModal', `${item.key}-${this.el.id}`);
        },

        editElement() {
            this.$store.commit('showModal', `element-edit-${this.el.id}`);
        },

    },

}

</script>
